import { BoxProps, Skeleton, SkeletonProps, useTheme } from "@mui/material";

import { mergeSx } from "@/common/helpers/mergeSx";
import { FormTypographyProps } from "@/forms-design-system/FormTypography";
import { InvalidThemeErrorMessage } from "@/forms-design-system/InvalidThemeErrorMessage";

export type FormSkeletonProps = SkeletonProps & {
  vibe?: "light" | "dark";
  maxWidth?: BoxProps["maxWidth"];
  minWidth?: BoxProps["minWidth"];
  fontSize?: FormTypographyProps["variant"];
};

export const FormSkeleton = ({ sx, maxWidth, minWidth, fontSize, vibe = "dark", ...rest }: FormSkeletonProps) => {
  const theme = useTheme();

  if (!theme.palette.forms || !theme.palette.formsComponents?.skeleton) {
    return <InvalidThemeErrorMessage />;
  }

  const gotFontProperties = () => {
    if (!fontSize || !(fontSize in theme.typography)) {
      return {};
    }
    const typographyVariant = theme.typography[fontSize as keyof typeof theme.typography];
    return typeof typographyVariant === "object" && "fontSize" in typographyVariant
      ? {
          fontSize: typographyVariant.fontSize,
          lineHeight: typographyVariant.lineHeight,
        }
      : {};
  };

  const styles = mergeSx(
    {
      maxWidth,
      minWidth,
      backgroundColor:
        vibe === "dark"
          ? theme.palette.formsComponents.skeleton.darkBackgroundColor
          : theme.palette.formsComponents.skeleton.lightBackgroundColor,
      ...gotFontProperties(),
    },
    sx
  );

  return <Skeleton sx={styles} {...rest} />;
};
